export default [
  'PLATFORM',
  'JOBS',
  'INTERVIEWS',
  'SURVEYS',
  'REVIEWS',
  'CAREER_PATHS'
].reduce((acc, cv) => ({ ...acc, [cv]: cv }), {});
